import { layoutSmall } from 'core/util/default'
import React from 'react'
import styled, { css } from 'styled-components'

interface SectionTitleProps {
  className?: string
}

const SectionTitle: React.FC<SectionTitleProps> = (props) => {
  return <StyledSectionTitle className={props.className}>{props.children}</StyledSectionTitle>
}

const StyledSectionTitle = styled.div`
  margin-top: 8px;
  padding: 12px 20px 8px 20px;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.icon};
  ${layoutSmall(css`
    padding: 12px 16px 8px 16px;
  `)}
`
export default SectionTitle
